<template>
  <div>
    <el-dialog :title="feeMeta.title" :visible.sync="dialogVisible" width="630px" @close="handleClose" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="tempFeeForm" label-width="100px">
        <el-form-item label="房屋">
          <span>{{ form.roomName }}</span>
        </el-form-item>
        <el-form-item label="收费金额" prop="amount">
          <el-input v-model="form.amount" placeholder="请输入金额" style="width: 100%;"></el-input>
        </el-form-item>
        <el-form-item label="支付方式" prop="primeRate">
          <el-select v-model="form.primeRate" placeholder="请选择支付方式" style="width: 100%;">
            <el-option v-for="(item, index) in primeRates" :key="index"
              :label="item.name" :value="item.statusCd">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="可选，填写备注信息"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitTempFeePay">确认收费</el-button>
      </div>
    </el-dialog>

    <el-dialog title="收费结果" :visible.sync="resultVisible" width="400px" @close="handleResultClose" :close-on-click-modal="false">
      <div style="text-align: center; padding: 20px;">
        <p>{{ feeMeta.title }}成功，金额：{{ resultAmount }} 元</p>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="handleResultClose">返回</el-button>
        <el-button v-if="receiptId" type="primary" @click="printReceipt">打印收据</el-button>
        <el-button v-else type="info" :loading="receiptLoading" @click="queryAndPrint">查询并打印</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { tempFeePay } from '@/api/fee/tempFeePayApi'
import { getCommunityId, getDict } from '@/api/community/communityApi'
import { queryFeeReceipt, listFeePrintPages } from '@/api/fee/payFeeOrderApi'

export default {
  name: 'TempFeePay',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      feeType: 'temp',
      form: {
        roomId: '',
        roomName: '',
        amount: '0.00',
        primeRate: '',
        remark: ''
      },
      primeRates: [],
      rules: {
        amount: [
          { required: true, message: '请输入收费金额', trigger: 'blur' }
        ],
        primeRate: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ]
      },
      resultVisible: false,
      resultAmount: '',
      detailId: '',
      receiptId: '',
      receiptLoading: false,
      printUrl: '/#/pages/property/printPayFee'
    }
  },
  created() {
    this.loadPrintUrl()
  },
  computed: {
    // 费用类型信息：补充缴费/水费/电费/临停
    feeMeta() {
      const map = {
        temp: { title: '补充缴费', feeName: '补充缴费', feeTypeCd: '' },
        water: { title: '水费代收', feeName: '水费', feeTypeCd: '888800010015' },
        electric: { title: '电费代收', feeName: '电费', feeTypeCd: '888800010016' },
        parking: { title: '临停收费', feeName: '临停费用', feeTypeCd: '888800010020' }
      }
      return map[this.feeType] || map.temp
    }
  },
  methods: {
    open(params) {
      this.feeType = params.feeType || 'temp'
      this.form.roomId = params.roomId
      this.form.roomName = params.roomName
      this.form.amount = '0.00'
      this.form.primeRate = ''
      this.form.remark = ''
      this.loadPrimeRates()
      this.dialogVisible = true
    },
    // 加载支付方式字典（过滤扫码类 5/6/8）
    async loadPrimeRates() {
      try {
        const data = await getDict('pay_fee_detail', 'prime_rate')
        this.primeRates = data.filter(item =>
          item.statusCd !== '5' && item.statusCd !== '6' && item.statusCd !== '8'
        )
        // 默认选中第一项（现金）
        if (!this.form.primeRate && this.primeRates.length > 0) {
          this.form.primeRate = this.primeRates[0].statusCd
        }
      } catch (e) {
        console.error('获取支付方式字典失败', e)
      }
    },
    async loadPrintUrl() {
      try {
        const communityId = getCommunityId()
        const response = await listFeePrintPages({ page: 1, row: 1, state: 'T', communityId })
        if (response.data && response.data.length > 0) {
          this.printUrl = response.data[0].url
        }
      } catch (e) {
        // ignore
      }
    },
    async submitTempFeePay() {
      const amount = Number(this.form.amount)
      if (!this.form.amount || this.form.amount === '' || isNaN(amount) || amount <= 0) {
        this.$message.warning('请输入大于0的收费金额')
        return
      }
      try {
        await this.$refs.tempFeeForm.validate()
        this.loading = true
        const payload = {
          payerObjId: this.form.roomId,
          payerObjName: this.form.roomName,
          amount: amount,
          primeRate: this.form.primeRate,
          remark: this.form.remark || this.feeMeta.feeName
        }
        // 水费/电费等类型：传费用类型编码，后端自动创建对应费用配置
        if (this.feeMeta.feeTypeCd) {
          payload.feeTypeCd = this.feeMeta.feeTypeCd
          payload.feeName = this.feeMeta.feeName
        }
        const res = await tempFeePay(payload)
        this.resultAmount = this.form.amount
        this.detailId = res.data ? res.data.detailId : ''
        this.receiptId = ''
        this.dialogVisible = false
        this.$emit('success')
        this.resultVisible = true
        // 自动查询收据
        this.autoQueryReceipt()
      } catch (error) {
        if (error !== false) {
          this.$message.error(this.feeMeta.title + '失败：' + (error.message || '未知错误'))
        }
      } finally {
        this.loading = false
      }
    },
    async autoQueryReceipt() {
      if (!this.detailId) return
      try {
        this.receiptLoading = true
        const communityId = getCommunityId()
        const response = await queryFeeReceipt({
          detailIds: this.detailId,
          communityId,
          page: 1,
          row: 1
        })
        if (response.code === 0 && response.data && response.data.length > 0) {
          this.receiptId = response.data[0].receiptId
        }
      } catch (e) {
        // ignore
      } finally {
        this.receiptLoading = false
      }
    },
    async queryAndPrint() {
      if (!this.detailId) {
        this.$message.warning('缺少缴费明细信息')
        return
      }
      try {
        this.receiptLoading = true
        const communityId = getCommunityId()
        const response = await queryFeeReceipt({
          detailIds: this.detailId,
          communityId,
          page: 1,
          row: 1
        })
        if (response.code === 0 && response.data && response.data.length > 0) {
          this.receiptId = response.data[0].receiptId
          this.printReceipt()
        } else {
          this.$message.warning('收据尚未生成，请稍后再试')
        }
      } catch (e) {
        this.$message.error('查询收据失败')
      } finally {
        this.receiptLoading = false
      }
    },
    printReceipt() {
      if (!this.receiptId) {
        this.$message.warning('收据ID不存在')
        return
      }
      window.open(`${this.printUrl}?receiptId=${this.receiptId}&merge=OFF`)
    },
    handleClose() {
      this.form = { roomId: '', roomName: '', amount: '0.00', primeRate: '', remark: '' }
      if (this.$refs.tempFeeForm) {
        this.$refs.tempFeeForm.resetFields()
      }
    },
    handleResultClose() {
      this.resultVisible = false
      this.receiptId = ''
      this.detailId = ''
    }
  }
}
</script>
